export default "__VITE_ASSET__Cp$1Vk66__"